const routes = [
  {
    path: 'aggridcolwidth',
    name: 'aggridcolwidth',
    component: () => import(/* webpackChunkName: "aggridcolwidth" */ '@/modules/aggridcolwidth/index.vue')
  },
];

export default routes;